<template>
    <div style="display: flex;flex-direction:column;align-items:center;width: 100%;">
        
        <template v-if="tb.type=='a'">
            <van-button style="width:40%" @click="$emit('submit')" :color="tb.color" plain>{{tb.text?tb.text:'提交'}}</van-button>
          </template>  
         <template v-else-if="tb.type=='b'">
            <van-button type="primary" @click="$emit('submit')"  :color="tb.color" size="large">{{tb.text?tb.text:'提交'}}</van-button>
         </template>
         <template v-else-if="tb.type=='c'">
            <van-button round type="info" @click="$emit('submit')"   :color="tb.color" >{{tb.text?tb.text:'提交'}}</van-button>
         </template>

      <template v-else>
        <a href="javascript:" @click="$emit('submit')"  :style="{backgroundColor:tb.color}" class="weui-btn weui-btn_primary">
            {{tb.text?tb.text:'提交'}}
        </a>
      </template>  

 
   
   


    </div>
</template>


<script>
    import Vue from 'vue';
import { Button } from 'vant';
Vue.use(Button);
export default{
props:['tb']
}
</script>


<style>

</style>


// WEBPACK FOOTER //
// src/fields/Buttons.vue